import {
	arDZ,
	cs,
	da,
	de,
	enAU,
	enGB,
	enUS,
	es,
	et,
	fi,
	fr,
	hu,
	is,
	it,
	ja,
	ko,
	nb,
	nl,
	pl,
	pt,
	ptBR,
	ro,
	ru,
	sk,
	sv,
	tr,
	zhCN,
	zhTW,
} from 'date-fns/locale';

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_WEEK_START_DAY = 0; // Sunday

export const locales: {
	readonly arDZ: Locale;
	readonly ar: Locale;
	readonly ar_DZ: Locale;
	readonly cs: Locale;
	readonly cs_CZ: Locale;
	readonly 'cs-CZ': Locale;
	readonly da: Locale;
	readonly da_DK: Locale;
	readonly 'da-DK': Locale;
	readonly de: Locale;
	readonly de_DE: Locale;
	readonly 'de-DE': Locale;
	readonly enUS: Locale;
	readonly en_US: Locale;
	readonly 'en-US': Locale;
	readonly enGB: Locale;
	readonly en_UK: Locale;
	readonly 'en-UK': Locale;
	readonly 'en-GB': Locale;
	readonly en_GB: Locale;
	readonly enAU: Locale;
	readonly en_AU: Locale;
	readonly 'en-AU': Locale;
	readonly es: Locale;
	readonly es_ES: Locale;
	readonly 'es-ES': Locale;
	readonly et: Locale;
	readonly et_EE: Locale;
	readonly 'et-EE': Locale;
	readonly fi: Locale;
	readonly fi_FI: Locale;
	readonly 'fi-FI': Locale;
	readonly fr: Locale;
	readonly fr_FR: Locale;
	readonly 'fr-FR': Locale;
	readonly hu: Locale;
	readonly hu_HU: Locale;
	readonly 'hu-HU': Locale;
	readonly is: Locale;
	readonly is_IS: Locale;
	readonly 'is-IS': Locale;
	readonly it: Locale;
	readonly it_IT: Locale;
	readonly 'it-IT': Locale;
	readonly ja: Locale;
	readonly ja_JP: Locale;
	readonly 'ja-JP': Locale;
	readonly ko: Locale;
	readonly ko_KR: Locale;
	readonly 'ko-KR': Locale;
	readonly nb: Locale;
	readonly nb_NO: Locale;
	readonly 'nb-NO': Locale;
	readonly nl: Locale;
	readonly nl_NL: Locale;
	readonly 'nl-NL': Locale;
	readonly pl: Locale;
	readonly pl_PL: Locale;
	readonly 'pl-PL': Locale;
	readonly pt: Locale;
	readonly 'pt-PT': Locale;
	readonly pt_PT: Locale;
	readonly ptBR: Locale;
	readonly 'pt-BR': Locale;
	readonly pt_BR: Locale;
	readonly ro: Locale;
	readonly ro_RO: Locale;
	readonly 'ro-RO': Locale;
	readonly ru: Locale;
	readonly ru_RU: Locale;
	readonly 'ru-RU': Locale;
	readonly sk: Locale;
	readonly sk_SK: Locale;
	readonly 'sk-SK': Locale;
	readonly sv: Locale;
	readonly sv_SE: Locale;
	readonly 'sv-SE': Locale;
	readonly tr: Locale;
	readonly 'tr-TR': Locale;
	readonly tr_TR: Locale;
	readonly zhCN: Locale;
	readonly 'zh-CN': Locale;
	readonly zh_CN: Locale;
	readonly zhTW: Locale;
	readonly 'zh-TW': Locale;
	readonly zh_TW: Locale;
} = {
	arDZ,
	ar: arDZ,
	ar_DZ: arDZ,
	cs,
	cs_CZ: cs,
	'cs-CZ': cs,
	da,
	da_DK: da,
	'da-DK': da,
	de,
	de_DE: de,
	'de-DE': de,
	enUS,
	en_US: enUS,
	'en-US': enUS,
	enGB,
	en_UK: enGB,
	'en-UK': enGB,
	'en-GB': enGB,
	en_GB: enGB,
	enAU,
	en_AU: enAU,
	'en-AU': enAU,
	es,
	es_ES: es,
	'es-ES': es,
	et,
	et_EE: et,
	'et-EE': et,
	fi,
	fi_FI: fi,
	'fi-FI': fi,
	fr,
	fr_FR: fr,
	'fr-FR': fr,
	hu,
	hu_HU: hu,
	'hu-HU': hu,
	is,
	is_IS: is,
	'is-IS': is,
	it,
	it_IT: it,
	'it-IT': it,
	ja,
	ja_JP: ja,
	'ja-JP': ja,
	ko,
	ko_KR: ko,
	'ko-KR': ko,
	nb,
	nb_NO: nb,
	'nb-NO': nb,
	nl,
	nl_NL: nl,
	'nl-NL': nl,
	pl,
	pl_PL: pl,
	'pl-PL': pl,
	pt,
	'pt-PT': pt,
	pt_PT: pt,
	ptBR,
	'pt-BR': ptBR,
	pt_BR: ptBR,
	ro,
	ro_RO: ro,
	'ro-RO': ro,
	ru,
	ru_RU: ru,
	'ru-RU': ru,
	sk,
	sk_SK: sk,
	'sk-SK': sk,
	sv,
	sv_SE: sv,
	'sv-SE': sv,
	tr,
	'tr-TR': tr,
	tr_TR: tr,
	zhCN,
	'zh-CN': zhCN,
	zh_CN: zhCN,
	zhTW,
	'zh-TW': zhTW,
	zh_TW: zhTW,
} as const;

/**
 * Long format of a date without time, eg "June 16, 1971"
 */
export const longDateOnlyFormat: Intl.DateTimeFormatOptions = {
	day: '2-digit',
	month: 'short',
	year: 'numeric',
};

/**
 * Long format of a time without date, eg "2:34 AM"
 */
export const longTimeOnlyFormat: Intl.DateTimeFormatOptions = {
	hour: 'numeric',
	minute: 'numeric',
};

export const times: string[] = [
	'00:00',
	'00:30',
	'01:00',
	'01:30',
	'02:00',
	'02:30',
	'03:00',
	'03:30',
	'04:00',
	'04:30',
	'05:00',
	'05:30',
	'06:00',
	'06:30',
	'07:00',
	'07:30',
	'08:00',
	'08:30',
	'09:00',
	'09:30',
	'10:00',
	'10:30',
	'11:00',
	'11:30',
	'12:00',
	'12:30',
	'13:00',
	'13:30',
	'14:00',
	'14:30',
	'15:00',
	'15:30',
	'16:00',
	'16:30',
	'17:00',
	'17:30',
	'18:00',
	'18:30',
	'19:00',
	'19:30',
	'20:00',
	'20:30',
	'21:00',
	'21:30',
	'22:00',
	'22:30',
	'23:00',
	'23:30',
];
